export const GLOBAL_STATE = 'Quiz-assessment'

export const QUIZ_BY_ID = 'QUIZ_BY_ID'
export const QUIZ_CREATE = 'QUIZ_CREATE'
export const QUIZ_DELETE = 'QUIZ_DELETE'
export const QUIZ_ALL = 'QUIZ_ALL'
export const QUIZ_LIST = 'QUIZ_LIST'
export const QUIZ_PUBLISH = 'QUIZ_PUBLISH'

export const QUIZ_CACHE_BY_ID = 'QUIZ_CACHE_BY_ID'
export const QUIZ_CACHE_ALL = 'QUIZ_CACHE_ALL'

export const QUIZ_RESET_OPEN = 'QUIZ_RESET_OPEN'
export const QUIZ_RESET_OPEN_ALL = 'QUIZ_RESET_OPEN_ALL'

export const QUIZ_RESULT_OPEN = 'QUIZ_RESULT_OPEN'
export const QUIZ_RESULTS = 'QUIZ_RESULTS'
export const QUIZ_RESULT = 'QUIZ_RESULT'

export const QUIZ_TYPES = 'QUIZ_TYPES'
